import React, {
  useState,
  useEffect
} from "react";

import {
  Box,
  Typography,
  Button,
  Grid,
  Paper,
  Stack,
  Container,
  Chip
} from "@mui/material";

import { useNavigate } from "react-router-dom";

import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import VerifiedIcon from "@mui/icons-material/Verified";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const heroImages = [
  "https://images.unsplash.com/photo-1509358271058-acd22cc93898",
  "https://images.unsplash.com/photo-1596040033229-a9821ebd058d",
  "https://images.unsplash.com/photo-1615485925600-97237c4fc1ec",
  "https://images.unsplash.com/photo-1583225157631-f3edf7a24f5e"
];

const categories = [
  {
    title: "Garam Masala",
    image:
      "https://images.unsplash.com/photo-1596040033229-a9821ebd058d"
  },
  {
    title: "Turmeric",
    image:
      "https://images.unsplash.com/photo-1615485925600-97237c4fc1ec"
  },
  {
    title: "Red Chilli",
    image:
      "https://images.unsplash.com/photo-1583225157631-f3edf7a24f5e"
  },
  {
    title: "Kitchen King",
    image:
      "https://images.unsplash.com/photo-1599909535318-8b4f7b1fd2c1"
  }
];

const HomePage = () => {
  const navigate = useNavigate();

  const [activeImage, setActiveImage] =
    useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveImage((prev) =>
        prev === heroImages.length - 1
          ? 0
          : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        background: "#fff8f2",
        overflowX: "hidden"
      }}
    >
      {/* HERO SECTION */}
      <Box
        sx={{
          position: "relative",
          background:
            "linear-gradient(135deg,#5c0000 0%, #8B0000 100%)",
          color: "#fff",
          py: {
            xs: 6,
            md: 10
          },
          overflow: "hidden"
        }}
      >
        <Container maxWidth="xl">
          {/* BACKGROUND ICON */}
          <Box
            sx={{
              position: "absolute",
              top: -120,
              right: -100,
              opacity: 0.06
            }}
          >
            <LocalFireDepartmentIcon
              sx={{
                fontSize: 420
              }}
            />
          </Box>

          <Grid
            container
            spacing={{
              xs: 5,
              md: 8
            }}
            alignItems="flex-start"
          >
            {/* LEFT CONTENT */}
            <Grid item xs={12} md={6}>
              <Chip
                label="India’s Premium Spice Experience"
                sx={{
                  bgcolor:
                    "rgba(255,255,255,0.14)",
                  color: "#fff",
                  fontWeight: 700,
                  mb: 3,
                  px: 1,
                  backdropFilter:
                    "blur(10px)"
                }}
              />

              <Typography
                sx={{
                  fontWeight: 900,
                  lineHeight: 1.05,
                  fontSize: {
                    xs: "3rem",
                    md: "5.5rem"
                  },
                  mb: 3,
                }}
              >
                SwadVeda Masale
              </Typography>

              <Typography
                sx={{
                  fontSize: {
                    xs: 16,
                    md: 20
                  },
                  lineHeight: 1.9,
                  opacity: 0.92,
                  maxWidth: 620,
                  mb: 5
                }}
              >
                Authentic Indian spices
                crafted with purity,
                freshness and traditional
                recipes to bring rich aroma
                and unforgettable taste to
                every kitchen.
              </Typography>

              {/* BUTTONS */}
              <Stack
                direction={{
                  xs: "column",
                  sm: "row"
                }}
                spacing={2}
              >
                <Button
                  variant="contained"
                  onClick={() =>
                    navigate("/shop")
                  }
                  endIcon={
                    <ArrowForwardIcon />
                  }
                  sx={{
                    bgcolor: "#fff",
                    color: "#8B0000",
                    px: 5,
                    py: 1.8,
                    borderRadius: "999px",
                    textTransform: "none",
                    fontWeight: 800,
                    fontSize: 16,
                    boxShadow: "none",

                    "&:hover": {
                      bgcolor: "#fff2ef",
                      boxShadow: "none"
                    }
                  }}
                >
                  Shop Now
                </Button>

                <Button
                  variant="outlined"
                  sx={{
                    borderColor:
                      "rgba(255,255,255,0.5)",
                    color: "#fff",
                    px: 5,
                    py: 1.8,
                    borderRadius: "999px",
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: 16,

                    "&:hover": {
                      borderColor:
                        "#fff",
                      background:
                        "rgba(255,255,255,0.06)"
                    }
                  }}
                >
                  Explore Recipes
                </Button>
              </Stack>

              {/* TRUST BAR */}
              <Stack
                direction={{
                  xs: "column",
                  md: "row"
                }}
                spacing={2}
                mt={6}
              >
                {[
                  {
                    icon: (
                      <WorkspacePremiumIcon />
                    ),
                    label: "100% Pure"
                  },
                  {
                    icon: (
                      <RestaurantIcon />
                    ),
                    label:
                      "Authentic Taste"
                  },
                  {
                    icon: (
                      <LocalShippingIcon />
                    ),
                    label:
                      "Freshly Packed"
                  }
                ].map((item) => (
                  <Paper
                    key={item.label}
                    elevation={0}
                    sx={{
                      px: 2.5,
                      py: 1.5,
                      borderRadius:
                        "999px",
                      bgcolor:
                        "rgba(255,255,255,0.12)",
                      color: "#fff",
                      display: "flex",
                      alignItems:
                        "center",
                      gap: 1.2,
                      backdropFilter:
                        "blur(10px)"
                    }}
                  >
                    {item.icon}

                    <Typography
                      fontWeight={700}
                    >
                      {item.label}
                    </Typography>
                  </Paper>
                ))}
              </Stack>
            </Grid>

            {/* RIGHT CAROUSEL */}
           <Grid
  item
  xs={12}
  md={6}
  sx={{
    display: "flex",
    alignItems: "flex-start"
  }}
>
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: {
                    xs: 300,
                    md: 350
                  },
                  borderRadius: "40px",
                  overflow: "hidden",
                  boxShadow:
                    "0 35px 90px rgba(0,0,0,0.3)"
                }}
              >
                {heroImages.map(
                  (image, index) => (
                    <Box
                      key={index}
                      component="img"
                      src={image}
                      sx={{
                        position:
                          "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit:
                          "cover",
                        transition:
                          "opacity 1s ease-in-out",
                        opacity:
                          activeImage ===
                          index
                            ? 1
                            : 0
                      }}
                    />
                  )
                )}

                {/* OVERLAY */}
                <Box
                  sx={{
                    position:
                      "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(to top, rgba(0,0,0,0.55), rgba(0,0,0,0.08))"
                  }}
                />

                {/* TEXT */}
                <Box
                  sx={{
                    position:
                      "absolute",
                    bottom: 35,
                    left: 35,
                    zIndex: 2
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "1.7rem",
                        md: "2.5rem"
                      },
                      fontWeight: 900,
                      mb: 1
                    }}
                  >
                    Authentic
                    <br />
                    Indian Flavors
                  </Typography>

                  <Typography
                    sx={{
                      opacity: 0.9,
                      maxWidth: 340,
                      lineHeight: 1.8
                    }}
                  >
                    Crafted with
                    traditional spice
                    recipes and premium
                    ingredients.
                  </Typography>
                </Box>

                {/* DOTS */}
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{
                    position:
                      "absolute",
                    bottom: 25,
                    right: 25,
                    zIndex: 2
                  }}
                >
                  {heroImages.map(
                    (_, index) => (
                      <Box
                        key={index}
                        sx={{
                          width:
                            activeImage ===
                            index
                              ? 28
                              : 10,
                          height: 10,
                          borderRadius:
                            "999px",
                          bgcolor:
                            activeImage ===
                            index
                              ? "#fff"
                              : "rgba(255,255,255,0.5)",
                          transition:
                            "0.35s"
                        }}
                      />
                    )
                  )}
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* WHY CHOOSE US */}
      <Box
        sx={{
          py: {
            xs: 8,
            md: 12
          },
          background:
            "linear-gradient(135deg,#fff1eb,#fff8f2)"
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            fontWeight={900}
            color="#5c0000"
            mb={2}
            textAlign="center"
          >
            Why Choose SwadVeda?
          </Typography>

          <Typography
            color="text.secondary"
            textAlign="center"
            maxWidth={700}
            mx="auto"
            mb={8}
            lineHeight={1.9}
          >
            Inspired by authentic Indian
            spice traditions, we focus on
            purity, freshness, hygiene and
            unforgettable flavors.
          </Typography>

          <Grid container spacing={4}>
            {[
              {
                title:
                  "Premium Ingredients",
                desc:
                  "Carefully sourced whole spices from trusted farms."
              },
              {
                title: "Fresh Aroma",
                desc:
                  "Advanced packaging keeps every spice naturally fresh."
              },
              {
                title:
                  "Authentic Recipes",
                desc:
                  "Traditional Indian masala blends perfected over time."
              },
              {
                title:
                  "No Artificial Colors",
                desc:
                  "Pure and clean spices for everyday cooking."
              }
            ].map((item) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                key={item.title}
              >
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    borderRadius: "30px",
                    height: "100%",
                    bgcolor: "#fff",
                    border:
                      "1px solid rgba(139,0,0,0.08)",
                    transition:
                      "0.35s ease",

                    "&:hover": {
                      transform:
                        "translateY(-8px)",
                      boxShadow:
                        "0 18px 40px rgba(0,0,0,0.08)"
                    }
                  }}
                >
                  <VerifiedIcon
                    sx={{
                      color: "#8B0000",
                      fontSize: 42,
                      mb: 2
                    }}
                  />

                  <Typography
                    variant="h6"
                    fontWeight={800}
                    mb={1.5}
                    color="#5c0000"
                  >
                    {item.title}
                  </Typography>

                  <Typography
                    color="text.secondary"
                    lineHeight={1.8}
                  >
                    {item.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default HomePage;